import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popup from 'reactjs-popup';

import css from '../../css/errors/popupError.module.scss';
import { selectError, setPopupError } from '../../slice/errorSlice';

export const PopupError: React.FC = () => {
    const { popupError } = useSelector(selectError);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setIsOpen(popupError !== null);
    }, [popupError]);

    const closeHandler = () => {
        setIsOpen(false);
        dispatch(setPopupError(null));
    };

    return (
        <Popup
            open={isOpen}
            modal
            nested
            overlayStyle={{ background: 'rgba(0, 0, 0, 0.7)' }}
            onClose={() => closeHandler()}
        >
            {(close: () => void) => (
                <div className={css.popup}>
                    <p>{popupError}</p>
                    <span onClick={() => close()}>キャンセル</span>
                </div>
            )}
        </Popup>
    );
};
